import { Row, Col, Select, Input, Button, Spin } from 'antd';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { DeleteOutlined } from '@ant-design/icons';

import { AddsContainer, StyledInput } from './common';
import { clearNumber } from './utils';

const { Option } = Select;

const IconCol = styled(Col)`
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

function Miscellaneous({ deleteSubItem, changeSubItem, item }) {
  const [localCost, setLocalCost] = useState(String(item.unit_cost ?? ''));
  const [removing, setRemoving] = useState(false);
  const [localQuantity, setLocalQuantity] = useState(
    String(item.quantity ?? '')
  );

  useEffect(() => {
    setLocalCost(String(item.unit_cost ?? ''));
  }, [item.unit_cost]);

  useEffect(() => {
    setLocalQuantity(String(item.quantity ?? ''));
  }, [item.quantity]);

  const onRemove = () => {
    setRemoving(true);

    setTimeout(() => {
      deleteSubItem();
    }, 300);
  };

  return (
    <Row style={{ marginTop: '10px' }}>
      <Col span={11}>
        <Input
          style={{ width: '90%' }}
          placeholder="Add misc."
          value={item.description}
          onChange={(e) => {
            const { value } = e.target;
            changeSubItem({
              description: value,
            });
          }}
          data-testid="add-misc-input"
        />
      </Col>
      <Col span={2}>
        <StyledInput
          onClick={(e) => e.stopPropagation()}
          value={localQuantity}
          onChange={(e) => {
            const cleanedValue = clearNumber(e.target.value);
            setLocalQuantity(cleanedValue);
          }}
          onBlur={() => {
            const finalValue = parseFloat(localQuantity);
            if (!isNaN(finalValue)) {
              changeSubItem({ quantity: parseFloat(finalValue.toFixed(2)) });
            } else {
              changeSubItem({
                quantity: 0,
              });
            }
          }}
          data-testid="misc-hours-input"
        />
      </Col>
      <Col span={5} style={{ paddingLeft: '20px' }}>
        <StyledInput
          onClick={(e) => e.stopPropagation()}
          prefix="$"
          value={localCost}
          onChange={(e) => {
            const cleanedValue = clearNumber(e.target.value);
            setLocalCost(cleanedValue);
          }}
          onBlur={() => {
            const finalValue = parseFloat(localCost);
            if (!isNaN(finalValue)) {
              changeSubItem({ unit_cost: finalValue });
            } else {
              changeSubItem({
                unit_cost: 0,
              });
            }
          }}
          data-testid="misc-rate-input"
        />
      </Col>
      <Col span={5} style={{ paddingLeft: '20px' }}>
        <StyledInput
          onClick={(e) => e.stopPropagation()}
          prefix="$"
          value={String((item.unit_cost * item.quantity).toFixed(2))}
          readOnly
          data-testid="misc-amount-input"
        />
      </Col>
      <IconCol span={1}>
        <Button
          icon={<DeleteOutlined />}
          style={{ fontSize: '20px' }}
          type="text"
          danger
          onClick={onRemove}
          loading={removing}
          data-testid="misc-delete-button"
        />
      </IconCol>
    </Row>
  );
}

export default Miscellaneous;
